import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  ACTIVITY_MACRO,
  ACTIVITY_MACRO_CURRENT_MONTH,
  ACTIVITY_PANEL,
  ACTIVITY_PAYMENTS,
} from '@app/@core/constants/routes.constants';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ActivityGuard } from './activity.guard';

const routes: Routes = [
  {
    path: ACTIVITY_PAYMENTS,
    loadChildren: () => import('./payment-reports/payment-reports.module').then((m) => m.PaymentReportsModule),
    data: { title: marker('sidenav.menu.reports.payments') },
    canActivate: [ActivityGuard],
  },
  {
    path: ACTIVITY_PANEL,
    loadChildren: () => import('./activityPanel/activityPanel.module').then((m) => m.PanelModule),
    data: { title: marker('sidenav.menu.reports.panel') },
    canActivate: [ActivityGuard],
  },
  {
    path: ACTIVITY_MACRO_CURRENT_MONTH,
    loadChildren: () =>
      import('./macro-current-month/macro-current-month.module').then((m) => m.MacroCurrentMonthModule),
    data: { title: marker('sidenav.menu.reports.current-month') },
    canActivate: [ActivityGuard],
  },
  {
    path: ACTIVITY_MACRO,
    loadChildren: () => import('./macro/macro.module').then((m) => m.MacroModule),
    data: { title: marker('sidenav.menu.reports.detail') },
    canActivate: [ActivityGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActivityRoutingModule {}
